import {useEffect} from 'react';
import {navigate} from '../../../utils/navigation';
import {useLocation} from 'react-router-dom';
import PageContainer from '../page-container';
import Components from '../../components';

import Triggers from '../../../lib/triggers';

export default () => {
    const param = new URLSearchParams(window.location.search),
          location = useLocation();

    useEffect(() => {
        Triggers.page_view({
            page: "payments_fail",
            paymentId: param.get('paymentId')
        });
    }, [location]);

    useEffect(() => {
        Components.Loader.close();
    }, []);

    return (
        <PageContainer>
            <div className="payment-result">
                <div className="icon failed">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.75 12L10.58 14.83L16.25 9.17001" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div className="title">Failed!</div>
                <div className="description">The bank has rejected the operation for your payment <b>{param.get('paymentId')}</b>.</div>
                <div className="description">Check the balance on your card and try again in <b>15-30</b> minutes.</div>
                <div className="button" onClick={e => navigate('/')}>Go home</div>
            </div>
        </PageContainer>
    )
}